import { render, staticRenderFns } from "./CategoryContentAttaches.vue?vue&type=template&id=e7d63e0a&scoped=true&"
import script from "./CategoryContentAttaches.vue?vue&type=script&lang=js&"
export * from "./CategoryContentAttaches.vue?vue&type=script&lang=js&"
import style0 from "./CategoryContentAttaches.vue?vue&type=style&index=0&id=e7d63e0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d63e0a",
  null
  
)

export default component.exports